import React from "react";

import {
  Flag,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TruncateTooltip,
  Typography,
} from "@tiny/components";
import { GeolocationTableProps } from "./GeolocationTable.types";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";

function GeolocationTable(props: GeolocationTableProps) {
  const { data, eventName, borderless } = props;

  return (
    <Table size="small" sidePadding={0} borderless={borderless}>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography
              variant="label1"
              color="grey"
              tone={600}
              fontWeight="bold"
            >
              Country
            </Typography>
          </TableCell>
          <TableCell align="right" width="80px">
            <Typography
              variant="label1"
              color="grey"
              tone={600}
              fontWeight="bold"
            >
              {eventName}
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((country) => (
          <TableRow key={country.countryCode}>
            <TableCell>
              <Grid container>
                <Grid item flex="0 0 36px" container alignItems="center">
                  <Flag code={country.countryCode} size={26} mr={2} />
                </Grid>
                <Grid item flex="1" container alignItems="center">
                  <TruncateTooltip arrow>
                    <Typography
                      display="block"
                      variant="label1"
                      label="Country"
                      color="grey"
                      tone={800}
                      noWrap
                    >
                      {country.countryName}
                    </Typography>
                  </TruncateTooltip>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell align="right">
              <Typography
                variant="label1"
                label="Total"
                color="grey"
                tone={900}
                fontWeight="bold"
              >
                {formatNumber(country.count)}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default React.memo(GeolocationTable);
